import { render, staticRenderFns } from "./MessageDispatchConfig.vue?vue&type=template&id=609936b9&scoped=true"
import script from "./MessageDispatchConfig.vue?vue&type=script&lang=js"
export * from "./MessageDispatchConfig.vue?vue&type=script&lang=js"
import style0 from "./MessageDispatchConfig.vue?vue&type=style&index=0&id=609936b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609936b9",
  null
  
)

export default component.exports